import React from 'react';
import { Spin, Modal } from 'antd';
import DspxCropper from '../../../../../../components/DspxCropper';
import { useHeaderImgData } from '../../../../hooks/useHeaderImgData';
import useAddHeaderImg from '../../../../mutations/useAddHeaderImg';
import { createSendHeaderImgData } from '../../../../utils/createSendHeaderImgData';
import useDeleteHeaderImg from '../../../../mutations/useDeleteHeaderImg';
import styles from './HeaderImg.module.scss';

const { confirm } = Modal;

const HeaderImg = ({ infoId }) => {
  const { data, isFetching, limits, aspect, fileAccept, UploadCoverContent } =
    useHeaderImgData(infoId);

  const { file, croppedFile, zoom, initialCroppedArea } = data || {};

  const { add, loading } = useAddHeaderImg();
  const { deleteHeaderImg } = useDeleteHeaderImg();

  const handleCropOk = (rawData, reset) => {
    const { croppedArea, ...other } = rawData;
    const data = createSendHeaderImgData({ ...other, ...croppedArea });
    add({ infoId, data, reset });
  };

  const handleDelete = () => {
    confirm({
      title: 'Удалить изображение?',
      okText: 'Удалить',
      okType: 'danger',
      onOk: async () => {
        await deleteHeaderImg({ infoId });
      },
      onCancel: () => {},
    });
  };

  return (
    <Spin spinning={Boolean(isFetching)}>
      {Boolean(data) && (
        <div className={styles.container}>
          <DspxCropper
            file={file}
            croppedFile={croppedFile}
            zoom={zoom}
            initialCroppedArea={initialCroppedArea}
            limits={limits}
            aspect={aspect}
            fileAccept={fileAccept}
            uploadContent={<UploadCoverContent />}
            confirmLoading={loading}
            onCropOk={handleCropOk}
            onDelete={handleDelete}
          />
        </div>
      )}
    </Spin>
  );
};

export default HeaderImg;
